module.exports = __webpack_public_path__ + "img/map1.87781c98.png";